module.exports = __webpack_public_path__ + "img/message.eb935da0.svg";